// Module
var code = `<base-button btn-type="{{btnType}}" btn-size="{{btnSize}}" btn-context="{{btnContext}}"> <i class="fa fa-clone"></i> <span ng-if="!btnIconOnly">{{ 'Generic.Copy' | translate }}</span> </base-button> `;
// Exports
module.exports = code;